import AlgoliaSearchBox from './AlgoliaSearchBox';

export default AlgoliaSearchBox;
